import { render } from "./SelectSlug.vue?vue&type=template&id=71e2b824"
import script from "./SelectSlug.vue?vue&type=script&lang=js"
export * from "./SelectSlug.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/project/wp-content/themes/resource-database/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__